<template>
    <div>
        <input type="hidden" name="done" value="1">
        <div class="row form-group">
            <label for="time_spent" class="col-sm-3 col-form-label text-right">
                {{trans('time_spent')}}
            </label>
            <div class="col-sm-2">
                <el-input v-model="form.time_spent" name="time_spent">

                </el-input>
            </div>
        </div>
        <div class="row form-group">
            <div class="offset-sm-1 col-sm-5" v-if="!task.copied">
                <div class="row">
                    <div class="col-sm-5 text-right">
                        <el-switch v-model="form.move_diff_hours" name="move_diff_hours">
                        </el-switch>
                    </div>
                    <label for="move_diff_hours" class="col-sm-7 col-form-label">
                        {{trans('move_diff_hours')}}
                    </label>
                </div>
            </div>
            <div v-if="form.move_diff_hours" class="col-sm-2">
                <el-input v-model="form.hours_for_move" name="hours_for_move">
                </el-input>
            </div>
            <label v-if="form.move_diff_hours" for="hours_for_move" class="col-sm-2 col-form-label">
                {{trans('hours')}}
            </label>
        </div>
        <div class="row form-group">
            <label for="done_comment" class="col-sm-3 col-form-label text-right">
                {{trans('done_comment')}}
            </label>
            <div class="col-sm-8">
                <el-input type="textarea" v-model="form.done_comment" name="done_comment">
                </el-input>
            </div>
        </div>
        <div v-if="!task.copied && !task.one_time">
            <div class="row form-group">
                <div class="offset-sm-3 col-sm-8">
                    <el-switch
                            v-model="form.copy"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-text="trans('copy_values.yes')"
                            :inactive-text="trans('copy_values.no')"
                            name="copy"
                    >
                    </el-switch>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "task-modal-done",
        props: {
            task: Object,
        },
        data() {
            return {

                form: {
                    time_spent: this.task.timers_duration ? this.task.timers_duration : this.task.estimated_hours,
                    move_diff_hours: false,
                    hours_for_move: (this.task.remaining_hours == this.task.estimated_hours) ? 0 : this.task.remaining_hours,
                    done_comment: this.task.done_comment,
                    copy: true,
                }
            }
        },
        watch: {
            'form.time_spent': function (newValue) {
                this.form.hours_for_move = this.task.estimated_hours - newValue;
            }
        },
        methods: {
            trans(fieldName) {
                let text = Lang.trans('tasks.fields.' + fieldName);
                return text ? text : 'undefined';
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tasks/TaskModalDone.vue